import { FC } from 'react'
import { useGetLacquerTypesQuery } from '../../../store/api/lacquer-types-api'
import { Form, Select } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import _ from 'lodash'
import { requiredOneElementRules } from '../../../constants/forms/validation/rules'
import LacquerTypeInterface from '../../../types/api/lacquer-type'

interface LacquerTypeProps {
    namePath: NamePath
    valueProp?: keyof LacquerTypeInterface
}

const LacquerType: FC<LacquerTypeProps> = ({ namePath, valueProp = 'documentId' }) => {
    const name = _.concat(namePath, 'type')
    const { data } = useGetLacquerTypesQuery()
    const list = data?.data || []

    return (
        <Form.Item name={name} label={'Тип лака'} rules={requiredOneElementRules}>
            <Select options={list.map(x => ({ label: x.name, value: x[valueProp] }))} />
        </Form.Item>
    )
}

export default LacquerType
